export const API_CONFIG = {
  OPENROUTER: {
    BASE_URL: "https://openrouter.ai/api/v1",
    API_KEY: import.meta.env.VITE_OPENROUTER_API_KEY,
    SITE_URL: "https://mindcomb-t3.vercel.app",
    SITE_NAME: "Mindcomb"
  }
}